import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPassword = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_626_1977)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4 5.3693V4.70264C4 2.4935 5.79086 0.702637 8 0.702637C10.2091 0.702637 12 2.4935 12 4.70264V5.3693H13.3333C13.7015 5.3693 14 5.66778 14 6.03597V14.036C14 14.4042 13.7015 14.7026 13.3333 14.7026H2.66667C2.29848 14.7026 2 14.4042 2 14.036V6.03597C2 5.66778 2.29848 5.3693 2.66667 5.3693H4ZM12.6667 6.70264H3.33333V13.3693H12.6667V6.70264ZM7.33333 10.5242C6.9348 10.2937 6.66667 9.86284 6.66667 9.3693C6.66667 8.6329 7.2636 8.03597 8 8.03597C8.7364 8.03597 9.33333 8.6329 9.33333 9.3693C9.33333 9.86284 9.0652 10.2937 8.66667 10.5242V12.036H7.33333V10.5242ZM5.33333 5.3693H10.6667V4.70264C10.6667 3.22988 9.47273 2.03597 8 2.03597C6.52724 2.03597 5.33333 3.22988 5.33333 4.70264V5.3693Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_626_1977",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0 0.0358887)"
		})
	}) })]
});
export default SvgPassword;
